import {useEffect, useState} from "react";
import {css} from "@emotion/css";
import {TagService} from "../../serverService/tagService/TagService";
import {LoadingHelper} from "../../util/LoadingHelper";
import {useLoadingDispatcher} from "../../context/LoadingContext";
import {
    RaikoButtonPrimary,
    RaikoFlexAlignEnd,
    RaikoGridOneColumn, RaikoSimpleInputOutlined,
    showErrorMessage,
    showSuccessMessage,
    showWarningMessage
} from "@moeindal/base-raiko-panel-components";
import {detectServerErrorMessage} from "../../util/detectServerErrorMessage";

export default function TagDetail({tagId = -1, handleAddNewItem, handleUpdateItem,}) {


    const service = new TagService()
    const loading = new LoadingHelper(useLoadingDispatcher())


    const [buttonTitle, setButtonTitle] = useState("افزودن");
    const [tagTitle, setTagTitle] = useState("")


    useEffect(() => {
        if (tagId >= 0) {
            getTagDetailFromServer()
            setButtonTitle("بروزرسانی")

        }
    }, [tagId]);

    function getTagDetailFromServer() {

        loading.show()
        service.getTagDetail(tagId)
            .then(response => {
                setTagTitle(response.name)
            }).catch(reason => {
            showErrorMessage(detectServerErrorMessage(reason))
        }).finally(_ => {
            loading.hide()
        })
    }

    function handleOperation() {
        if (tagTitle.trim().length > 0) {
            if (tagId >= 0) {
                handleUpdateTag()
            } else {
                handleCreateTag()
            }
        } else
            showWarningMessage("لطفا نام تگ را به درستی وارد نمایید.")
    }

    function handleUpdateTag() {
        loading.show()
        service.updateTag(tagId, tagTitle)
            .then(response => {
                showSuccessMessage("تگ با موفقیت بروزرسانی شد.")
                handleUpdateItem(tagId, response.name)
            }).catch(reason => {
            showErrorMessage(detectServerErrorMessage(reason))
        }).finally(_ => {
            loading.hide()
        })
    }

    function handleCreateTag() {
        loading.show()
        service.addNewTag(tagTitle)
            .then(response => {
                showSuccessMessage("تگ جدید با موفقیت افزوده شد.")
                setTagTitle("")
                handleAddNewItem(response.name)
            }).catch(reason => {
            showErrorMessage(detectServerErrorMessage(reason))
        }).finally(_ => {
            loading.hide()
        })
    }

    return (
        <RaikoGridOneColumn className={css`padding: 0 1rem 1rem 1rem;`}>
            <RaikoSimpleInputOutlined labelText={"نام"} setValue={setTagTitle} value={tagTitle}/>
            <RaikoFlexAlignEnd>
                <RaikoButtonPrimary label={buttonTitle} onClick={handleOperation}/>
            </RaikoFlexAlignEnd>
        </RaikoGridOneColumn>
    )
}
